export function digestMessage (message) {
    const encoder = new TextEncoder();
    return window.crypto.subtle.digest(
        "SHA-512",
        encoder.encode(message)
    );
}

export default digestMessage;
